import React from 'react';
import {Container,Grid,styled,Typography} from '@mui/material'
import {Outlet} from 'react-router-dom';
import Comunication from './Comunication';
import ComunicationPhone from './ComunicationPhone';
import ComunicationEmail from './ComunicationEmail';
import AdPtojrcts from '../reklam/AdPtojrcts';
import TeamData from '../datas/TeamData';
import TeamItem from '../helpers/TeamItem';

function Team() {
  return (
    <>
      <AdPtojrcts/>
      <Comunication/>
      <ComunicationPhone/>
      <ComunicationEmail/>
      <Container sx={{marginBottom:3,marginTop:2}}>
      <Typography variant='h4' component='h4' sx={{marginBottom:2, textAlign:'center'}} className='projectWriting'>Ekip İle Buluşalım</Typography>
        <Grid sx={{marginBottom:3}}>
          <Grid sx={{display:'flex', flexDirection:'row',flexWrap:'wrap', justifyContent:'center',gap:'50px'}}>
              {TeamData.map((Item, key) => {
                return(
                  <TeamItem
                  key={key}
                  {...Item}
                  loading='lazy'
                  />
                )
              })}
          </Grid>
        </Grid>
      </Container>
      <Outlet/>
    </>
    
  )
}

export default Team;